// Service layer for horarios-related HTTP requests.
// Keeps fetch/axios logic centralized.

import { post } from './http';

const STORAGE_KEY = 'geppro_horarios';
const API_BASE = process.env.REACT_APP_API_URL || '';
const USE_MOCK = !API_BASE || API_BASE === '';

function saveToLocalStorage(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (err) {
    console.error('Failed to save horarios:', err);
  }
}

export async function postHorarios(payload) {
  if (USE_MOCK) {
    return new Promise((resolve) => {
      setTimeout(() => {
        saveToLocalStorage(payload);
        resolve({ success: true, schedules: payload });
      }, 200);
    });
  }
  try {
    return await post('/api/horarios', { schedules: payload });
  } catch (err) {
    console.warn('API failed, using mock:', err);
    saveToLocalStorage(payload);
    return { success: true, schedules: payload };
  }
}

export async function getHorarios() {
  if (USE_MOCK) {
    return new Promise((resolve) => {
      setTimeout(() => {
        try {
          const json = localStorage.getItem(STORAGE_KEY);
          const schedules = json ? JSON.parse(json) : [];
          resolve({ success: true, schedules });
        } catch {
          resolve({ success: true, schedules: [] });
        }
      }, 150);
    });
  }
  try {
    const res = await fetch(`${API_BASE}/api/horarios`);
    if (!res.ok) throw new Error('Failed to fetch');
    return await res.json();
  } catch (err) {
    console.warn('API failed, using mock:', err);
    try {
      const json = localStorage.getItem(STORAGE_KEY);
      const schedules = json ? JSON.parse(json) : [];
      return { success: true, schedules };
    } catch {
      return { success: true, schedules: [] };
    }
  }
}

const horariosService = { postHorarios, getHorarios };
export default horariosService;
